export default [
  {
    path: '/komcards-dashboard',
    name: 'komcards-dashboard',
    component: () => import('@/views/pages/komcards/dashboard/Index.vue'),
    meta: {
      resource: 'Komcards - Dashboard',
      navActiveLink: 'komcards-dashboard',
      action: 'read',
    },
  },
  {
    path: '/komcards-data-partner',
    name: 'komcards-data-partner',
    component: () => import('@/views/pages/komcards/data-partner/Index.vue'),
    meta: {
      resource: 'Komcards - Data Partner',
      navActiveLink: 'komcards-data-partner',
      action: 'read',
    },
  },
  {
    path: '/komcards-data-partner/:id',
    name: 'komcards-data-partner-detail',
    component: () => import('@/views/pages/komcards/data-partner/Detail/Index.vue'),
    meta: {
      resource: 'Komcards - Data Partner',
      navActiveLink: 'komcards-data-partner',
      action: 'read',
    },
  },
  {
    path: '/komcards-data-partner/mutation/:id',
    name: 'komcards-mutation',
    component: () => import('@/views/pages/komcards/data-partner/Mutation/List.vue'),
    meta: {
      resource: 'Komcards - Data Partner',
      navActiveLink: 'komcards-data-partner',
      action: 'read',
    },
  },
  {
    path: '/komcards-data-partner/sync-transaction/:id',
    name: 'komcards-mutation-sync',
    component: () => import('@/views/pages/komcards/data-partner/Sync-transaction/List.vue'),
    meta: {
      resource: 'Komcards - Data Partner',
      navActiveLink: 'komcards-data-partner',
      action: 'read',
    },
  },
  {
    path: '/komcards-data-partner/insufficient-balance/:id',
    name: 'insufficient-balance',
    component: () => import('@/views/pages/komcards/data-partner/insufficient-balance/List.vue'),
    meta: {
      resource: 'Komcards - Data Partner',
      navActiveLink: 'komcards-data-partner',
      action: 'read',
    },
  },
  {
    path: '/komcards-dashboard/topup-history',
    name: 'topup-history',
    component: () => import('@/views/pages/komcards/dashboard/topup-history/Index.vue'),
    meta: {
      resource: 'Komcards - Dashboard',
      navActiveLink: 'komcards-dashboard',
      action: 'read',
    },
  },
  {
    path: '/komcards-dashboard/data-kartu',
    name: 'komcards-data-kartu',
    component: () => import('@/views/pages/komcards/data-kartu/List.vue'),
    meta: {
      resource: 'Komcards - Data Kartu',
      navActiveLink: 'komcards-data-kartu',
      action: 'read',
    },
  },
  {
    path: '/komcards-dashboard/monitoring-check-balance-transaction',
    name: 'monitoring-check-balance-transaction',
    component: () => import('@/views/pages/komcards/monitoring-check-balance-transaction/List.vue'),
    meta: {
      resource: 'Komcards - Monitoring Check Balance Transaction',
      navActiveLink: 'monitoring-check-balance-transaction',
      action: 'read',
    },
  },
  {
    path: '/komcards-dashboard/monitoring-check-balance-transaction/missing-transaction/:id',
    name: 'transaction-missing',
    component: () => import('@/views/pages/komcards/monitoring-check-balance-transaction/MissingTransactions.vue'),
    meta: {
      resource: 'Komcards - Monitoring Check Balance Transaction',
      navActiveLink: 'monitoring-check-balance-transaction',
      action: 'read',
    },
  },
  {
    path: '/komcards-dashboard/monitoring-check-top-up-idle',
    name: 'monitoring-check-top-up-idle',
    component: () => import('@/views/pages/komcards/monitoring-check-top-up-idle/List.vue'),
    meta: {
      resource: 'Komcards - Monitoring Check Top Up Idle',
      navActiveLink: 'monitoring-check-top-up-idle',
      action: 'read',
    },
  },
]
